// import log from 'salvo-lite/log'

class SetViewportHeight {
    constructor () {
        this._name = this.constructor.name
    }

    onInit () {
        this._setHeight()
        window.addEventListener('resize', this._setHeight)
    }

    _setHeight () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
}

export default SetViewportHeight



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SetViewportHeight.js